import type {
  AbstractControl,
  UntypedFormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

/**
 * Validates form array controls in context of control value uniqueness.
 * <br/><strong>Note:</strong> the validator works for string based control values only.
 * @param formArray - form controls array
 * @param controlValuePath - control value accessor path, ex.: 'title'
 * @param valueModifierFn - define how should values be modified before comparison (optional)
 */
export function controlUniquenessValidator(
  formArray: UntypedFormArray,
  controlValuePath: string,
  valueModifierFn?: (value: string) => string,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    formArray.controls.reduce(
      (acc, option) => {
        const pureKey = <string>option.get(controlValuePath)?.value ?? '';

        if (pureKey.length === 0) {
          return acc;
        }

        const key = valueModifierFn ? valueModifierFn(pureKey) : pureKey;
        const count = acc[key] ?? 0;

        return {
          ...acc,
          [key]: count + 1,
        };
      },
      <Record<string, number>>{},
    )[valueModifierFn ? valueModifierFn(<string>control.value) : <string>control.value] > 1
      ? { unique: false }
      : null;
}

export const trimValueModifier = (value: string) => value.trim();
